import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class MessagesService {
  private API_MESSAGES_URL = environment.API_URL + "api/Messages/MessageList";
  private API_MESSAGES_FIND_URL = environment.API_URL + "api/Messages";

  constructor(private http: HttpClient) {}

  getMessages() {
    return this.http.get(this.API_MESSAGES_URL);
  }

  getMessage(id: any) {
    return this.http.get(`${this.API_MESSAGES_FIND_URL}/${id}`);
  }

  createMessage(value: any) {
    return this.http.post(this.API_MESSAGES_FIND_URL, value);
  }

  updateMessage(value: any, id: number) {
    value.id = id;
    return this.http.put(`${this.API_MESSAGES_FIND_URL}/${id}`, value);
  }
}
